<template>
  <Overlay
    v-if="$sitewideConfig.config.internationalSitePopupEnabled && internationalSite"
    unique-key="internationalSite"
    animation-style="FADE"
    modal-width="XSMALL"
    mode="BLACK"
    @closed="close"
  >
    <template #noPadding>
      <div class="py-6 px-4 text-white text-center">
        <div class="mb-6">
          <span>Welcome to&nbsp;</span>
          <span class="font-bold">{{ $sitewideConfig.config.siteName }}</span>
        </div>
        <div class="mb-6">
          To shop for products that ship to your location, please visit our {{ internationalSite.siteText }}.
        </div>
        <div class="flex gap-x-6 justify-center">
          <button type="button" class="underline py-3 px-2" @click="close">
            Stay on {{ internationalSite.originSite }} site
          </button>
          <NuxtLink
            :to="internationalSite.domain"
            target="_blank"
            class="rounded bg-primary text-black py-3 px-2 font-bold"
          >
            Go to {{ internationalSite.siteText }}
          </NuxtLink>
        </div>
      </div>
    </template>
  </Overlay>
</template>

<script setup lang="ts">
const { $overlay, $sitewideConfig } = useNuxtApp()
const location = useLocation()

const { data: internationalSites } = await useFetch(`/api/${$sitewideConfig.domain}/international-sites`)

const internationalSite = computed(() => {
  if (!internationalSites.value || !location.state.value.edge.countryCode) return
  return internationalSites.value.find((item) => item.countryCodes.includes(location.state.value.edge.countryCode))
})

onMounted(() => {
  if (internationalSite.value) $overlay.open('internationalSite')
})

function close() {
  $overlay.close()
}
</script>
